module.exports = __webpack_public_path__ + "img/banner-main-web-01-kor.9f30c16d.png";